// Not generated from samples: written from Appboy::Communication::Segment::DatabricksCohortFilter, which shares
// PartnerCohortImportFilterBase with the Hightouch cohort filter.

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const databricksCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("databricks_cohort_filter"),
  // strict_field :c enum IN / NOT_IN
  comparison_key: z.enum(["7", "8"]),
  display_name: z.string(),
  raw_value: z.string().optional(),
  value: z.object({
    id: z.string(),
    value: z.string().nullable(),
  }),
  varies_by_app_group: z.literal(true),
});
